import { createAction, props } from '@ngrx/store';

export const setLoading = createAction(
  '[Loading] Set Loading',
  props<{ loading: boolean; feature?: string }>()
);
export const startLoading = createAction(
  '[Loading] Start Loading',
  props<{ feature?: string }>()
);
export const stopLoading = createAction(
  '[Loading] Stop Loading',
  props<{ feature?: string }>()
);
